/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Release_LabelInputs */

const en_audio_description_export_automix_release_label = /** @type {(inputs: Audio_Description_Export_Automix_Release_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release`)
};

const fr_audio_description_export_automix_release_label = /** @type {(inputs: Audio_Description_Export_Automix_Release_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relâchement`)
};

const de_audio_description_export_automix_release_label = /** @type {(inputs: Audio_Description_Export_Automix_Release_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freigeben`)
};

const it_audio_description_export_automix_release_label = /** @type {(inputs: Audio_Description_Export_Automix_Release_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicazione`)
};

const ru_audio_description_export_automix_release_label = /** @type {(inputs: Audio_Description_Export_Automix_Release_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выпускать`)
};

const es_audio_description_export_automix_release_label = /** @type {(inputs: Audio_Description_Export_Automix_Release_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liberar`)
};

const zh_cn2_audio_description_export_automix_release_label = /** @type {(inputs: Audio_Description_Export_Automix_Release_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布`)
};

const ja_audio_description_export_automix_release_label = /** @type {(inputs: Audio_Description_Export_Automix_Release_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リリース`)
};

const hi_audio_description_export_automix_release_label = /** @type {(inputs: Audio_Description_Export_Automix_Release_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुक्त करना`)
};

const pt_pt2_audio_description_export_automix_release_label = /** @type {(inputs: Audio_Description_Export_Automix_Release_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liberar`)
};

/**
* | output |
* | --- |
* | "Release" |
*
* @param {Audio_Description_Export_Automix_Release_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_release_label = /** @type {((inputs?: Audio_Description_Export_Automix_Release_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Release_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_release_label(inputs)
	if (locale === "de") return de_audio_description_export_automix_release_label(inputs)
	if (locale === "it") return it_audio_description_export_automix_release_label(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_release_label(inputs)
	if (locale === "es") return es_audio_description_export_automix_release_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_release_label(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_release_label(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_release_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_release_label(inputs)
	return en_audio_description_export_automix_release_label(inputs)
});